export default "__VITE_ASSET__6eff2529__"